/**
 * Route for `fraud-analyst-workbench-case-review-queue`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { FraudAnalystWorkbenchCaseReviewQueuePage } from "../features/fraud-analyst-workbench-case-review-queue/FraudAnalystWorkbenchCaseReviewQueuePage";

export const fraudAnalystWorkbenchCaseReviewQueueRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/fraud-analyst-workbench-case-review-queue",
	component: FraudAnalystWorkbenchCaseReviewQueuePage,
});

export default fraudAnalystWorkbenchCaseReviewQueueRoute;
